import { type UserTextProps, UserText } from '@halo/ui-chat-react';
import { useActionsStore } from '@/store/actions';
import { useSessionContentsContext } from '../session-parts/session-contents/session-contents-context';

export interface MsgUserTextProps extends Omit<UserTextProps, 'children'> {
  userName: string;
  userId?: string;
}

export const MsgUserText = memo(function MsgUserText({
  userName,
  userId,
  ...props
}: MsgUserTextProps) {
  const fetchProfileUser = useActionsStore((store) => store.fetchProfileUser);
  const { sessionStoreInstance } = useSessionContentsContext();

  const onClick = useCallback(() => {
    const groupAccess = sessionStoreInstance?.getState()?.groupAccess;
    const readonly = !groupAccess?.canPrivateMessage;
    if (userId) {
      fetchProfileUser(userId, true, readonly);
    }
  }, [fetchProfileUser, userId, sessionStoreInstance]);

  return (
    <UserText onClick={onClick} {...props}>
      {userName}
    </UserText>
  );
});
